module.exports = "<div *ngIf=\"rawHtmlPermission\">\n  <span class=\"html-switch\" (click)=\"toggleEditorAndRaw()\">\n    Switch to <span *ngIf=\"!rawHtmlSwitchOn\">html</span><span *ngIf=\"rawHtmlSwitchOn\">rich text</span>\n  </span>\n</div>\n<div [hidden]=\"!setupComplete\">\n  <textarea\n    [id]=\"elementId\"\n    [value]=\"editorContent\"\n    rows=\"10\"\n    [placeholder]=\"placeholder\"\n  >\n  </textarea>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/shared/editor/editor.component.html
// module id = ../../../../../src/app/shared/editor/editor.component.html
// module chunks = 2